// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { Check, Loader2, AlertCircle } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { SaveStatus } from '@/hooks/useAutosave'

interface SaveStatusBadgeProps {
  status:    SaveStatus
  className?: string
}

export function SaveStatusBadge({ status, className }: SaveStatusBadgeProps) {
  return (
    <div className={cn('flex items-center gap-1.5 text-xs transition-all duration-200', className)}>
      {status === 'idle' && (
        // Altijd zichtbaar: geeft gebruiker zekerheid dat teruggaan veilig is
        <>
          <Check className="h-3 w-3 text-ink-4" />
          <span className="text-ink-4">Automatisch opgeslagen</span>
        </>
      )}
      {status === 'saving' && (
        <>
          <Loader2 className="h-3 w-3 animate-spin text-ink-4" />
          <span className="text-ink-4">Opslaan…</span>
        </>
      )}
      {status === 'saved' && (
        <>
          <Check className="h-3 w-3 text-sage-600" />
          <span className="text-sage-600">Opgeslagen</span>
        </>
      )}
      {status === 'error' && (
        <>
          <AlertCircle className="h-3 w-3 text-status-alertText" />
          <span className="text-status-alertText">Opslaan mislukt</span>
        </>
      )}
    </div>
  )
}
